import { atom } from "nanostores";

/**
 * @description Store to observe if consent is given.
 * This store does not store the consent type (none, full, partial),
 * but only if consent has been given.
 */
export const isConsentReadyStore = atom<boolean>(false);
